import { Container, Grid, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useLocation, useNavigate } from 'react-router-dom';
import { IPaymentManage } from '../../_common/interface/payment/iPaymentManage';
import { PrimaryButton } from '../../_components/button/primary.button';
import { TextValidatorHcs } from '../../_components/textValidator/textValidatorHcs';
import { toastr } from '../../_components/toastr/toastr';
import { getFormattedTimezoneOffset, getMoneyFormat } from '../../_helpers/format.helper';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { handleInput } from '../../_helpers/input.helper';
import { getWindowSizeCategory } from '../../_helpers/windowSize.helper';
import { paymentService } from '../../_services/payment.service';
import PaymentAuthenticate from './payment-authenticate';
import { OPAYO_SCRIPT, OPAYO_URL } from '../../_config/config.const';

export function PaymentForm() {
    const location = useLocation();
    const navigate = useNavigate();

    const { userCartId, amount } = location.state || {};

    const resetCardDetails = () => ({
        cardholderName: null,
        cardNumber: null,
        expiryDate: null,
        securityCode: null
    });

    const [errors, setErrors] = useState({
        cardholderName: '',
        cardNumber: '',
        expiryDate: '',
        securityCode: ''
    });

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isExtraCheck, setIsExtraCheck] = useState<boolean>(true);
    const [merchantSessionKey, setMerchantSessionKey] = useState<string | null>(null);
    const [cardIdentifier, setCardIdentifier] = useState<string | null>(null);
    const [cardDetails, setCardDetails] = useState<IPaymentManage>(resetCardDetails);
    const [transactionId, setTransactionId] = useState<string | undefined>(undefined);
    const [acsUrl, setAcsUrl] = useState<string | undefined>(undefined);
    const [creq, setCreq] = useState<string | undefined>(undefined);

    useEffect(() => {
        fetchMerchantSessionKey();
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = OPAYO_SCRIPT;
        //script.src = 'https://sandbox.opayo.eu.elavon.com/api/v1/js/sagepay.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        console.log(7);
        if (!!cardIdentifier) {
            console.log(8);
            submitPayment();
        }
    }, [cardIdentifier]);

    function handleSubmit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        console.log(1);
        if (!merchantSessionKey) {
            toastr.error("Something went wrong. Please try again");
            console.error('Merchant Session Key is not available');
            console.log(2);
            setIsSaving(false);
            return;
        }
        console.log(3);
        (window as any).sagepayOwnForm({
            merchantSessionKey
        }).tokeniseCardDetails({
            cardDetails: cardDetails,
            onTokenised: (result: any) => {
                console.log(4);
                if (result.success) {
                    // console.log(5, result);
                    setCardIdentifier(result.cardIdentifier);
                } else {
                    console.log("nope_6");
                    //alert(JSON.stringify(result));
                    toastr.error(" Something went wrong. Please try again.");
                    setIsSaving(false);
                }
            }
        });

    };

    function submitPayment() {
        var _paymentDetails = {
            ...paymentDetails,
            userCartId: userCartId,
            paymentMethod: {
                card: {
                    merchantSessionKey: merchantSessionKey,
                    cardIdentifier: cardIdentifier
                }
            }
        };

        return paymentService
            .post(_paymentDetails, isExtraCheck)
            .then(
                (res) => {
                    console.log(10, res);
                    switch (res.statusCode || res.code) {
                        case "0000":
                            toastr.success(" Payment was successful!");
                            navigate("../paymentConfirmation")
                            break;
                        case "2000":
                            toastr.error(" The authorization was Declined by the bank.");
                            break;
                        case "2021":
                            setAcsUrl(res.acsUrl);
                            setTransactionId(res.transactionId)
                            setCreq(res.cReq);
                            break;
                        case 1002:
                            toastr.error(" Authentication failed.")
                            break;
                        case 1003:
                            toastr.error(" Missing mandatory field.")
                            break;
                        case 1004:
                            toastr.error(" The cardholder name is too long.")
                            break;
                        case 1005:
                            if (res.property == "cardDetails.cardholderName")
                                toastr.error(" The cardholder name contains invalid characters.")
                            else if (res.propert == "cardDetails.expiryDate") {
                                toastr.error(" The expiry date has to be in MMYY format.")
                            }
                            break;
                        default:
                            console.log(res.statusCode || res.code);
                            toastr.error(" Something went wrong. Please contact support.");
                            break;
                    }
                    console.log("end");
                    console.log(11, res);
                    setMerchantSessionKey(null);
                    setCardIdentifier(null);
                    // setCardDetails(resetCardDetails);
                    setErrors({
                        cardNumber: '',
                        cardholderName: '',
                        expiryDate: '',
                        securityCode: '',
                    });
                },
                (e) => {
                    console.log(e);
                    toastr.error(" Something went wrong. Please contact support.")
                }
            )
            .finally(() => {
                setIsSaving(false);
                fetchMerchantSessionKey()
            });
    }

    function reset() {
        setMerchantSessionKey(null);
        setCardIdentifier(null);
        setAcsUrl(undefined);
        setCreq(undefined)
        setErrors({
            cardNumber: '',
            cardholderName: '',
            expiryDate: '',
            securityCode: '',
        });
        fetchMerchantSessionKey();
    }

    function fetchMerchantSessionKey() {
        setIsSaving(true);
        return paymentService
            .getMerchantSessionKey(isExtraCheck)
            .then(
                (json) => {
                    setMerchantSessionKey(json.merchantSessionKey);
                }, (e) => {
                    handleErrorResponse(e);
                }
            ).finally(() => {
                setIsSaving(false);
            });
    }

    const paymentDetails = {
        userCartId,
        transactionType: "Payment",
        paymentMethod: {
            card: {
                merchantSessionKey: merchantSessionKey,
                cardIdentifier: cardIdentifier
            }
        },
        vendorTxCode: "",
        amount: 3000,
        currency: "EUR",
        description: "",
        customerFirstName: "Sam",
        customerLastName: "Jones",
        customerPhone: "+353871111111",
        billingAddress: {
            address1: "88",
            city: "London",
            postalCode: "412",
            country: "GB"
        },
        strongCustomerAuthentication: {
            website: "",
            notificationURL: OPAYO_URL,
            browserIP: "",
            browserAcceptHeader: "",
            browserJavascriptEnabled: true,
            browserJavaEnabled: false,
            browserLanguage: navigator.language,
            browserColorDepth: window.screen.colorDepth,
            browserScreenHeight: window.screen.height,
            browserScreenWidth: window.screen.width,
            browserTZ: getFormattedTimezoneOffset(),
            "browserUserAgent": navigator.userAgent,
            challengeWindowSize: getWindowSizeCategory(),
            transType: "GoodsAndServicePurchase"
        }
    };

    function handleChange(event: any) {
        setCardDetails((_data) => ({ ..._data, [event.target.name]: event.target.value }))
        // Reset specific field error when user starts typing
        setErrors({
            ...errors,
            [event.target.name]: '',
        });
    };

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsExtraCheck(event.target.checked);
    };

    return (
        <>
            <Container>
                <Paper sx={{ padding: 3 }}>

                    <Typography variant="h3" textAlign="center" color="primary" marginBottom={2}>
                        Make a payment
                    </Typography>

                    {/*<FormControlLabel*/}
                    {/*    control={*/}
                    {/*        <Switch*/}
                    {/*            checked={isExtraCheck}*/}
                    {/*            onChange={(e) => { handleSwitchChange(e); fetchMerchantSessionKey() }}*/}
                    {/*            name="modeSwitch"*/}
                    {/*            color="primary"*/}
                    {/*        />*/}
                    {/*    }*/}
                    {/*    label="3D Auth"*/}
                    {/*/>*/}
                    <ValidatorForm onSubmit={handleSubmit} noValidate>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    name="cardholderName"
                                    label="Name"
                                    placeholder="Cardholder Name"
                                    fullWidth
                                    // id="cardHolder"
                                    variant="outlined"
                                    value={cardDetails.cardholderName}
                                    required
                                    maxLength={50}
                                    autocomplete="off"
                                    validators={['required', 'matchRegexp:^[a-zA-Z\\s]+$']}
                                    errorMessages={['Cardholder name is required', 'Invalid cardholder name']}
                                    shrink={true}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    name="cardNumber"
                                    label="Card"
                                    // id="cardNumber"
                                    placeholder="0000 0000 0000 0000"
                                    fullWidth
                                    variant="outlined"
                                    value={cardDetails.cardNumber}
                                    required
                                    autocomplete="off"
                                    shrink={true}
                                    validators={['required', 'matchRegexp:^\\d{12,16}$']}
                                    errorMessages={['Card number is required', 'Card number must be between 12 and 16 digits']}
                                    onInput={(e: any) => handleInput(e, 16)}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    name="expiryDate"
                                    label="Expiry"
                                    placeholder="MMYY"
                                    required
                                    fullWidth
                                    variant="outlined"
                                    value={cardDetails.expiryDate}
                                    validators={['required', 'matchRegexp:^\\d{4}$']}
                                    errorMessages={['Expiry date is required', 'Expiration date must be 4 digits']}
                                    shrink={true}
                                    onInput={(e: any) => handleInput(e, 4)}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    name="securityCode"
                                    label="CVV"
                                    placeholder="123"
                                    fullWidth
                                    // id="cardCsc"
                                    variant="outlined"
                                    value={cardDetails.securityCode}
                                    required
                                    validators={['required', 'matchRegexp:^\\d{3,4}$']}
                                    errorMessages={['CVV is required', 'CVV must be 3 or 4 digits']}
                                    shrink={true}
                                    onInput={(e: any) => handleInput(e, 4)}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <input type="hidden" name="card-identifier" />
                            </Grid>

                            {amount &&
                                <Grid item xs={12}>
                                    <Typography>Total Amount To Pay: {getMoneyFormat(amount)}</Typography>
                                </Grid>
                            }

                            <Grid item xs={12}>
                                <PrimaryButton
                                    isSaving={isSaving}
                                    type="submit"
                                    variant="save">{"Pay Now"}
                                </PrimaryButton>
                            </Grid>

                        </Grid>
                    </ValidatorForm>
                </Paper>


            </Container>

            <PaymentAuthenticate
                isOpen={transactionId != null && acsUrl != null && creq != null}
                transactionId={transactionId}
                acsUrl={acsUrl}
                creq={creq}
                onClose={reset}
            />
        </>
    );
};

